<template>
  <div class="explore_places img_container" style="">
    <PropertyCard
      v-if="property?.length"
      v-for="property in property"
      :key="property.id"
      class="explore_details cursor-pointer"
      @click="$router.push(`/place/${property.customId}`)"
      :property="property"
    />
    <NoResultFound v-else />
  </div>
</template>
<script setup>
import PropertyCard from "~/components/exploreAPlace/PropertyCard.vue";
//variable
const property = ref([]);
const config = useRuntimeConfig();

await getExploreProperties();

//methods
async function getExploreProperties() {
  if (property.value.length) return;
  try {
    const { data } = await useFetch(`${config.public.NUXT_API_URL}/explore`, {
      keys: `public-property-explore`,
    });
    if (data && data.value) {
      property.value = data.value.data;
      return data.value;
    }
    return [];
  } catch (error) {
    debug(error);
    return [];
  }
}
</script>
<style lang="scss" scoped>
.explore_places {
  padding: $padding;
  margin-inline: auto;
  display: grid;
  place-items: center;
  color: $color-light;
  @include respond-below(sm) {
    padding: 1rem;
  }
  .not-found {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70vh;
    h1 {
      font-size: $text-xxxl;
      color: rgba(255, 255, 255, 0.6);
    }
  }
}
.tick {
  color: #f1f1f1;
}
</style>
